import { h } from "preact";
import { Link } from "preact-router";
import logo from "../assets/images/blaenavon-weather-logo.png";
import styles from "./Logo.css";

/** The logo, which is also the way home — the first thing people try. */
const Logo = () => (
  <Link class={styles.link} href="/" aria-label="Blaenavon Weather, home">
    <img class={styles.logo} src={logo} alt="Blaenavon Weather" />
  </Link>
);

export default Logo;
